import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Thumbs, FreeMode, EffectFade } from 'swiper/modules';
import { Pagination, Navigation, EffectCube, Autoplay } from 'swiper/modules';

// Importar estilos de Swiper
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import './stories.css'

import image0 from "./../../assets/images-padrinos/30.png";
import image1 from "./../../assets/images-padrinos/31.png";
import image2 from "./../../assets/images-padrinos/32.png";
import image3 from "./../../assets/images-padrinos/33.png";
import image4 from "./../../assets/images-padrinos/34.png";
import image5 from "./../../assets/images-padrinos/35.png";
import image6 from "./../../assets/images-padrinos/36.png";
import image7 from "./../../assets/images-padrinos/37.png";
import image8 from "./../../assets/images-padrinos/38.png";
import image9 from "./../../assets/images-padrinos/39.png";
import image10 from "./../../assets/images-padrinos/40.png";
import image11 from "./../../assets/images-padrinos/42.png";
import image12 from "./../../assets/images-padrinos/43.png";

import story1 from "./../../assets/historias-images/1.png";
import story2 from "./../../assets/historias-images/2.png";
import story3 from "./../../assets/historias-images/3.png";
import story4 from "./../../assets/historias-images/4.png";
import story5 from "./../../assets/historias-images/5.png";
import story6 from "./../../assets/historias-images/6.png";
import story7 from "./../../assets/historias-images/7.png";
import story8 from "./../../assets/historias-images/8.png";
import story9 from "./../../assets/historias-images/9.png";
import story10 from "./../../assets/historias-images/10.png";
import story11 from "./../../assets/historias-images/11.png";
import story12 from "./../../assets/historias-images/12.png";
import story13 from "./../../assets/historias-images/5.webp";
import story14 from "./../../assets/historias-images/22.webp";

const styleSwiperStoryThb = {
    'width': '100%',
    'height': '100%',
}

const Stories = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);

    const openStories = (index) => {
        setActiveIndex(index);
        setIsModalOpen(true);
    };

    const infoPadrinos = [
        {
            id: 0,
            nombre: "",
            nombreHistoria: "Velación",
            cargo: "Padrinos de Velación",
            foto: image11,
            tipo: "imagen",
            historia: story1
        },
        {
            id: 1,
            nombre: "Angélica & Hugo",
            nombreHistoria: "Anillos",
            cargo: "Padrinos de anillos",
            foto: image0,
            tipo: "imagen",
            historia: story2
        },
        {
            id: 2,
            nombre: "Lety & Toño",
            nombreHistoria: "Arras",
            cargo: "Padrinos de arras",
            foto: image1, // Sin foto
            tipo: "texto",
            colorFondo: "linear-gradient(135deg, #4a5d4a, #8da38d)",
            historia: story3
        },
        {
            id: 22,
            nombre: "Teresa & Javier",
            nombreHistoria: "Lazo",
            cargo: "Padrinos de lazo",
            foto: image2, // Sin foto
            tipo: "texto",
            colorFondo: "linear-gradient(135deg, #4a5d4a, #8da38d)",
            historia: story13
        },
        {
            id: 12,
            nombre: "",
            nombreHistoria: "Ayate",
            cargo: "Ayate",
            foto: image12, // Sin foto
            tipo: "texto",
            colorFondo: "linear-gradient(135deg, #4a5d4a, #8da38d)", // Tu verde bosque
            historia: story12
        },
       
        {
            id: 4,
            nombre: "Angélica, Silvia & Lety",
            nombreHistoria: "Biblia",
            cargo: "Madrinas de Biblia y rosario",
            foto: image4, // Sin foto
            tipo: "texto",
            colorFondo: "linear-gradient(135deg, #4a5d4a, #8da38d)",
            historia: story8
        },
        {
            id: 11,
            nombre: "Dulce",
            nombreHistoria: "Ramo Novia",
            cargo: "Madrinas de ramo",
            foto: image3,
            tipo: "imagen",
            historia: story5
        },
        {
            id: 3,
            nombre: "Perla",
            nombreHistoria: "Ramo Ofrenda",
            cargo: "Madrinas de ramo",
            foto: image3,
            tipo: "imagen",
            historia: story4
        },
        {
            id: 6,
            nombre: "Lidia",
            nombreHistoria: "Cojín",
            cargo: "Madrina de cojín",
            foto: image6, // Sin foto
            tipo: "texto",
            colorFondo: "linear-gradient(135deg, #4a5d4a, #8da38d)",
            historia: story7
        },
        {
            id: 7,
            nombre: "Hilda",
            nombreHistoria: "Sagrada Familia",
            cargo: "Madrina de imagen",
            foto: image7,
            historia: story9 
        },
        /*{
            id: 9,
            nombre: "Carmen",
            nombreHistoria: "Fotografía",
            cargo: "Foto y video",
            foto: image9,
            tipo: "imagen" 
        },*/
         {
            id: 5,
            nombre: "Itzel, Irving, Nikesha & Diego",
            nombreHistoria: "Testigos Iglesia",
            cargo: "Testigos iglesia",
            foto: image5,
            historia: story10 
        },
        {
            id: 8,
            nombre: "Diana, Dani, Jairo & Paúl",
            nombreHistoria: "Testigos Civil",
            cargo: "Testigos Civil",
            foto: image8, // Sin foto
            tipo: "texto",
            colorFondo: "linear-gradient(135deg, #4a5d4a, #8da38d)", // Tu verde bosque,
            historia: story11
        },
        
        {
            id: 30,
            nombre: "",
            nombreHistoria: "Damas",
            cargo: "Damas",
            foto: image10, // Sin foto
            tipo: "texto",
            colorFondo: "linear-gradient(135deg, #4a5d4a, #8da38d)", // Tu verde bosque
            historia: story14
        }
    ];

    return (
        <>
            <Swiper
                autoHeight={false}
                slidesPerView={4}
                spaceBetween={9}
                centeredSlides={false}
                modules={[Pagination, FreeMode]}
                freeMode={true}
                className="storiesThumbnails"
                style={{marginTop: "4rem", marginBottom: "3rem", width: "100%", maxWidth: "100%"}}
        >

            {infoPadrinos.map((padrino, idx) => {
                return(
                    <SwiperSlide style={{ display: 'flex', justifyContent: 'center', flexDirection: "column", alignItems: "center"}}>
                        <div className="circle-wrapper" 
                            style={idx > 0 ? {
                            "background": "linear-gradient(45deg, #D300C5, #FFD702, #FE02B7, #FC2278, #FF2160, #FF5234)",
                            "border-radius": "50%",
                            "display": "inline-block",
                            "padding": "3px",
                            "width": "86px", 
                            "height": "86px"
                            }: {
                            "background": "linear-gradient(45deg, #00D535)",
                            "border-radius": "50%",
                            "display": "inline-block",
                            "padding": "3px",
                            "width": "86px", 
                            "height": "86px"
                            }}>
                            <img
                                src={padrino.foto}
                                loading="lazy"
                                style={styleSwiperStoryThb}
                                className='storyImage'
                                onClick={() => openStories(idx)}
                            />
                        </div>
                        <span className="thumb-name">
                            {padrino.nombreHistoria} {/* Muestra solo el primer nombre para que no se amontone */}
                        </span>
                    </SwiperSlide>
                )
            })}
            
        </Swiper>
        {isModalOpen && (
            <div className="stories-modal-overlay">
                <button className="close-button" onClick={() => setIsModalOpen(false)}>×</button>
                
                <Swiper
                    key={`modal-swiper-${activeIndex}`}
                    initialSlide={activeIndex}
                    effect={'cube'}
                    modules={[Navigation, EffectCube, Autoplay, Pagination]}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        type: 'progressbar', // <--- Esto crea la barra en lugar de puntos
                    }}
                    className="modal-swiper"
                >
                {infoPadrinos.map((p) => (
                    <SwiperSlide key={p.id}>
                    <div className="modal-story-content" style={{backgroundImage: `url(${p.historia})`}}>
                        <div className="story-header">
                        <img src={p.foto} className="mini-avatar" />
                        <span>{p.nombreHistoria}</span>
                        </div>
                        <div className="story-footer">
                        <p>{p.frase}</p>
                        </div>
                    </div>
                    </SwiperSlide>
                ))}
                </Swiper>
            </div>
            )}
        </>
    );
};

export default Stories;